import { Flex, Pagination, theme, type PaginationProps } from 'antd';

type HireportPaginationProps = PaginationProps & {
  bordered?: boolean;
  compact?: boolean;
};

function HireportPagination({
  bordered = true,
  compact = false,
  className,
  ...paginationProps
}: HireportPaginationProps) {
  const { token } = theme.useToken();
  return (
    <Flex
      justify="flex-end"
      className={className}
      data-testid="hireport-pagination"
      style={{
        padding: compact ? `${token.paddingSM}px 0` : `${token.padding}px 0`,
        borderTop:
          bordered !== false
            ? `1px solid ${token.colorBorderSecondary}`
            : undefined,
      }}
    >
      <Pagination size="small" {...paginationProps} />
    </Flex>
  );
}

export default HireportPagination;
